import * as React from "react";
import { useRecordContext } from "react-admin";
import { Button, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CheckIcon from "@mui/icons-material/Check";
import { adminPatch } from "../../config/api";
import useModerationAction from "../../hooks/useModerationAction";

export default function ValidateOobjectVariantButton() {
    const record = useRecordContext();
    const { loading, run } = useModerationAction();

    if (!record || record.status === "VALIDATED") return null;

    const onClick = async (event) => {
        event?.stopPropagation?.();
        await run({
            id: record.id,
            missingIdMessage: "ID variante manquant.",
            request: () => adminPatch(`/oobject-variants/${record.id}/validate`),
            successMessage: "Variante validée",
        });
    };

    return (
        <Tooltip title="Valider cette variante">
      <span>
        <Button
            onClick={onClick}
            disabled={loading}
            variant="contained"
            size="small"
            sx={{
                bgcolor: "#2e7d32",
                color: "white",
                borderRadius: "18px",
                textTransform: "none",
                px: 1.25,
                py: 0.25,
                "&:hover": { bgcolor: "#1b5e20" },
            }}
            startIcon={
                loading ? (
                    <CircularProgress size={14} sx={{ color: "white" }} />
                ) : (
                    <CheckIcon fontSize="small" />
                )
            }
        >
          Valider
        </Button>
      </span>
        </Tooltip>
    );
}
